import React, { useCallback } from "react"
import styled from "styled-components"
// import 'bootstrap/dist/css/bootstrap.min.css';
import { State, useHookstate } from "@hookstate/core"
import { Validation } from "@hookstate/validation"
import { useExhibitorDataState } from "../../globalStates/ExhibitorDataState"
import { useLanguageState } from "../../globalStates/LanguageState"
import {
    fieldNameByLang,
    getElementFieldValueWithLanguage,
    makeSetHandlerWithLanguage,
    makeValidationHandlerWithLanguage
} from "../../utils/Language"
import TextField from "../../components/Field/Text"
import Icon from "../../components/Icon"
import DownloadIcon from "../../images/download.svg"
import RemoveIcon from "../../images/remove.svg"
import Mp4PreviewIcon from "../../images/mp4.svg"
import PdfPreviewIcon from "../../images/pdf.svg"
import { Media } from "../../globalStates/ExhibitorDataTypes"

function mapSource(filename?: string, source?: string): string {
    if (!filename || !source) return "none"
    if (filename.endsWith("mp4") || filename.endsWith("MP4")) return Mp4PreviewIcon
    if (filename.endsWith("pdf") || filename.endsWith("PDF")) return PdfPreviewIcon
    return source
}

const MutimediaItemWrapper = styled.div`
    display: flex;
    align-items: center;
    margin: 25px -27.5px;
    & > * {
        margin: 0 27.5px;
    }
`

const MutimediaItemPos = styled.div`
    flex: 0 0 60px;
`

interface MutimediaItemImageProps {
    filename?: string
    source?: string
}

const MutimediaItemImage = styled.div<MutimediaItemImageProps>`
    flex: 0 0 163px;
    max-width: 133px;
    max-height: 133px;
    height: 133px;
    background-image: url(${(props) => mapSource(props.filename, props.source)});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
`

const MutimediaItemDetails = styled.div`
    display: flex;
    flex-flow: column;
    flex: 1 1 auto;
    margin-top: -5px;
    margin-bottom: -5px;
    label {
        margin-top: 13px;
        margin-bottom: 21px;
    }
    .form-group {
        margin: 0 !important;
        padding: 5px 0 !important;
        label {
            display: none;
        }
    }
`

const MutimediaItemActions = styled.div`
    flex: 0 0 55px;
    display: flex;
    justify-content: space-between;
    & > img {
        cursor: pointer;
    }
`

interface MutimediaContentProps {
    mediaState: State<Media, Validation>
    currentLanguage: string
    onRemoveMedia: (id: string) => void
}

const MutimediaItem: React.FC<MutimediaContentProps> = ({ mediaState, currentLanguage, onRemoveMedia }) => {
    const branding = useLanguageState().getStrings()
    const exiState = useExhibitorDataState()
    const media = useHookstate(mediaState)
    const downloadItem = useCallback(
        (event: React.MouseEvent<HTMLImageElement>) => {
            event.preventDefault()
            exiState.download(media.url.get(), media.name.get())
        },
        [exiState, media.name, media.url]
    )
    return (
        <MutimediaItemWrapper>
            <MutimediaItemPos>
                <TextField
                    name="position"
                    label=""
                    placeholder="#"
                    value={media.order.get()}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        media.order.set(Number(event.target.value))
                    }}
                />
            </MutimediaItemPos>
            <MutimediaItemImage filename={media.name.get()} source={media.url.get()} />
            <MutimediaItemDetails>
                <label>{media.name.get()}</label>
                <TextField
                    key={fieldNameByLang("title", currentLanguage)}
                    name={fieldNameByLang("title", currentLanguage)}
                    label=""
                    placeholder={branding.configuration.multimediaPage.sctMultimediaImage.hntTitle}
                    validate={makeValidationHandlerWithLanguage(media, "title", currentLanguage)}
                    value={getElementFieldValueWithLanguage(media, "title", currentLanguage)}
                    onChange={makeSetHandlerWithLanguage(media, "title", currentLanguage)}
                />
                <TextField
                    key={fieldNameByLang("subtitle", currentLanguage)}
                    name={fieldNameByLang("subtitle", currentLanguage)}
                    label=""
                    placeholder={branding.configuration.multimediaPage.sctMultimediaImage.hntSubtitle}
                    value={getElementFieldValueWithLanguage(media, "subtitle", currentLanguage)}
                    onChange={makeSetHandlerWithLanguage(media, "subtitle", currentLanguage)}
                />
            </MutimediaItemDetails>
            <MutimediaItemActions>
                <a href={media.url.get()} download>
                    <Icon src={DownloadIcon} onClick={downloadItem} />
                </a>
                <Icon src={RemoveIcon} onClick={() => onRemoveMedia(media.id.get())} />
            </MutimediaItemActions>
        </MutimediaItemWrapper>
    )
}
export default MutimediaItem
